import type { ReactNode } from 'react';

export function MetricTile({
  label,
  value,
  sub,
  icon,
  tone = 'default',
  className = '',
}: {
  label: string;
  value: string | number;
  sub?: string;
  icon?: ReactNode;
  tone?: 'default' | 'success' | 'warning' | 'danger' | 'ai' | 'gold';
  className?: string;
}) {
  const toneBorder = {
    default: 'border-white/10',
    success: 'border-emerald-500/25',
    warning: 'border-amber-500/25',
    danger: 'border-rose-500/25',
    ai: 'border-violet-500/25',
    gold: 'border-amber-400/30',
  }[tone];

  return (
    <div className={`rounded-2xl border bg-white/[0.03] px-3 py-2.5 ${toneBorder} ${className}`}>
      <div className="flex items-center gap-2">
        {icon ? <span className="text-zinc-400">{icon}</span> : null}
        <span className="text-[10px] font-semibold uppercase tracking-wide text-zinc-500">{label}</span>
      </div>
      <div className="font-display text-xl font-bold tabular-nums text-[var(--text-primary)]">{value}</div>
      {sub ? <div className="mt-0.5 text-[10px] text-[var(--text-muted)]">{sub}</div> : null}
    </div>
  );
}
